export const autoCompleterReqBody = (
  plantId = "",
  isDlpSearch,
  isDigitalSearch,
  filters = {},
  isBatchSearch = false,
  category = "MaterialMaster",
  isPlantIdRequired = true
) => {
  const plantIdParam = isPlantIdRequired
    ? {
        plantId:
          plantId || (isDlpSearch ? "DP01" : isDigitalSearch ? "DG01" : "HO01"),
      }
    : {};
  if (isBatchSearch) return autoCompleterReqBodyForBatch();
  return {
    tenant: "PHOENIX",
    category,
    value: "",
    oprId: "test123",
    params: {
      ...plantIdParam,
      ...(filters?.corpValues?.length > 0 && {
        courseAttribute: filters?.corpValues.map(({ value }) => value),
      }),

      ...(filters?.categoryDispValue && {
        categoryDispValue: Array.isArray(filters?.categoryDispValue)
          ? filters?.categoryDispValue.map((pkg) => pkg.value)
          : filters?.categoryDispValue.value,
      }),

      ...(filters["term.dispValue"] && {
        "term.dispValue": filters["term.dispValue"],
      }),
    },
  };
};

export const autoCompleterReqBodyForBatch = () => ({
  tenant: "PHOENIX",
  category: "StudentBatches",
  value: "",
  oprId: "test123",
});

export const initialFilterForm = {
  status: null,
  groupTypeIds: [],
};

export const getFilterCount = (filterForm, ignoreKeys = []) => {
  // changing this method can cause impact on multiple places, please check impact before changing anything
  let cnt = 0;
  for (let key in filterForm) {
    if (!ignoreKeys?.includes(key) && filterForm[key]?.toString().length) cnt++;
  }
  return cnt;
};

export const selectStyles = {
  control: {
    borderRadius: "4px",
    height: "40px",
  },
};
export const inputStyles = {
  borderRadius: "4px",
  height: "40px",
};

export const editCellContainerStyle = {
  width: "100%",
  padding: "0 10px",
};

export const newRow = {
  groupTypeId: "",
  materialNumber: "",
  status: "ACTIVE",
};

export const typeDropdown = [
  { label: "Onboarding", value: "ONBOARDING" },
  { label: "Multiple", value: "MULTIPLE" },
  { label: "Both", value: "BOTH" },
];
